// Bottom of Purchase Order / Purchase Invoice / Non-Tax Purchase Invoice:
// "Gross Amount" and "Line Discount" rows above the Subtotal — only when a
// line carries a discount (see utils/purchaseDiscount.js). Renders table rows.
import React from 'react';
import { formatAmount } from '../utils/documentNumbering';
import { lineDiscountSummary } from '../utils/purchaseDiscount';

const LineDiscountRows = ({ lines }) => {
  const { gross, lineDiscount } = lineDiscountSummary(lines);
  if (!(lineDiscount > 0)) return null;
  return (
    <>
      <tr><td>Gross Amount</td><td>{formatAmount(gross)}</td></tr>
      <tr><td>Line Discount</td><td>-{formatAmount(lineDiscount)}</td></tr>
    </>
  );
};

export default LineDiscountRows;
